import { Cliente } from './cliente.model';

export class Contrato {
    codigo: string
    selector: string    
    cliente: Cliente
    quantidade_dispositivo_ativo: number
}